import React from 'react';

/**
 * DataPoint - Summary data point display with outlined label
 *
 * @param {number|string} value - The main value to display
 * @param {string} label - Label text
 * @param {string} color - Border and text color for the label
 * @param {function} onClick - Optional click handler
 */
const DataPoint = ({ value, label, color, onClick }) => (
  <div
    className="text-center"
    onClick={onClick}
    style={{ cursor: onClick ? 'pointer' : 'default' }}
  >
    <h3 className="mb-2 fw-bold" style={{ fontSize: '1.75rem' }}>{value}</h3>
    <span
      className="px-3 py-1 rounded-pill d-inline-block text-center"
      style={{
        border: `2px solid ${color}`,
        color: color,
        fontSize: '0.8rem',
        fontWeight: 500,
        minWidth: '90px'
      }}
    >
      {label}
    </span>
  </div>
);

/**
 * PercentagePoint - Percentage stat display
 *
 * @param {number|string} value - The percentage value to display
 * @param {string} label - Label text
 */
const PercentagePoint = ({ value, label }) => (
  <div className="text-center">
    <h3 className="mb-2 fw-bold" style={{ fontSize: '1.75rem' }}>
      {value}<span style={{ fontSize: '1.1rem' }}>%</span>
    </h3>
    <span className="text-muted" style={{ fontSize: '0.8rem' }}>
      {label}
    </span>
  </div>
);

export { DataPoint, PercentagePoint };
export default DataPoint;
